import { Box, TextFieldProps, SxProps } from '@mui/material';
import { SectionHeader } from 'pages/Campaigns/components/SectionHeader';
import { ReactElement } from 'react';
import { Input, Props as InputProps } from './Inputs/Input';
import { EditableTextInput } from './Inputs/EditableTextInput';

const containerStyle: SxProps = {
  display: 'flex',
  gap: '5%'
};

export type TextFieldConfig = {
  label: string;
  props: InputProps;
  rightComponent?: ReactElement | null;
  withRemoveButton?: boolean;
  onRemove?: () => void;
  onSave?: (value: string) => void;
  maxCharacters?: number;
  inputContainerStyle?: SxProps;
  isEditableText?: boolean;
};

type CustomTextFieldProps = TextFieldProps & {
  title?: string;
  subTitle?: string | ReactElement;
  textFields?: TextFieldConfig[];
  customComponents?: (ReactElement | null)[];
  width?: number | string;
  headerId?: string;
  disableMargin?: boolean;
  FieldsContainer?: React.FC<any>;
  isVertical?: boolean;
};

/**
 * @deprecated use FormField from common/components/FormField
 */
const FormField: React.FC<CustomTextFieldProps> = ({
  title,
  subTitle,
  textFields,
  customComponents,
  disableMargin,
  headerId,
  width = '50%',
  FieldsContainer,
  isVertical
}) => {
  const Wrapper = FieldsContainer || Box;

  return (
    <Box
      id={headerId}
      sx={{
        ...containerStyle,
        marginBottom: disableMargin ? 0 : 4,
        flexDirection: isVertical ? 'column' : 'row'
      }}
    >
      <Box width={381}>
        {title && <SectionHeader title={title} subTitle={subTitle} />}
      </Box>
      <Box sx={{ width }}>
        <Wrapper>
          {textFields?.map((field, index) => {
            const {
              maxCharacters,
              inputContainerStyle,
              withRemoveButton,
              onRemove,
              isEditableText,
              onSave
            } = field;

            return (
              <Box
                key={`${field.label}-${index}`}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: disableMargin ? 0 : 4,
                  ...inputContainerStyle
                }}
              >
                <Box
                  sx={{ marginBottom: 2, width: '100%' }}
                  key={`text-field-${index}`}
                >
                  {isEditableText ? (
                    <EditableTextInput
                      label={field.label}
                      onSave={
                        onSave ||
                        (() => {
                          //
                        })
                      }
                      {...field.props}
                    />
                  ) : (
                    <Input
                      label={field.label}
                      {...field.props}
                      maxCharacters={maxCharacters}
                      withRemoveButton={withRemoveButton}
                      onRemove={onRemove}
                    />
                  )}
                </Box>
                {field?.rightComponent ? field.rightComponent : null}
              </Box>
            );
          })}
          <Box mt={isVertical ? 2 : 0}>
            {customComponents?.map((component, index) =>
              component ? (
                <Box key={`component-${index}`} mb={4}>
                  {component}
                </Box>
              ) : null
            )}
          </Box>
        </Wrapper>
      </Box>
    </Box>
  );
};

export { FormField };
